/** @jsxImportSource @emotion/react */
import dots from 'components/landing/images/dots.svg';
import {
  BlueLine,
  Button,
  colors,
  Container,
  Divider,
  HeadingH2,
  Section,
} from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

import bg from '../../images/s8-bg.svg';

const S8 = () => (
  <Container css={{ overflow: 'hidden' }}>
    <Section
      css={{
        paddingTop: 50,
        '@media (min-width:992px)': { paddingTop: 100 },
        '@media (min-width:1366px)': { paddingTop: 120 },
      }}
    >
      <div
        css={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
          position: 'relative',
          '@media (min-width:768px)': {
            minHeight: 576,
            paddingTop: 125,
            background: `url(${bg})`,
            backgroundRepeat: 'no-repeat',
            backgroundPositionY: 'top',
            backgroundPositionX: 'right',
          },
          '@media (min-width:1366px)': { backgroundPositionX: '95%' },
        }}
      >
        <HeadingH2 css={{ marginBottom: 20 }}>vk - BOSS В ЦИФРАХ</HeadingH2>
        <BlueLine
          height={5}
          width={125}
          css={{ marginBottom: 30, '@media (min-width:768px)': { marginBottom: 50 } }}
        />

        <div
          css={{
            backgroundColor: '#fff',
            marginBottom: 30,
            width: '100%',
            '>div': {
              flexDirection: 'column',
              alignItems: 'center',
              flexBasis: '100%',
              flexGrow: 0,
              border: `1px solid ${colors.grayDark}`,
              padding: 30,
              '>span': { fontWeight: 600, fontFamily: 'Open Sans' },
              '>span:nth-of-type(1)': { fontSize: 60, lineHeight: '82px', marginBottom: 20 },
              '>span:nth-of-type(2)': { fontSize: 16, lineHeight: '22px' },
            },
            flexDirection: 'column',
            '@media (min-width:992px)': {
              filter: `drop-shadow(-42px 39px 14px rgba(117, 117, 117, 0.25))`,
              flexDirection: 'row',
              '>div': {
                alignItems: 'flex-start',
                flexBasis: '33%',
                flexGrow: 1,
              },
            },
            '@media (min-width:1366px)': { marginBottom: 50 },
          }}
        >
          <div>
            <span css={{ color: colors.black }}>+400</span>
            <span css={{ color: colors.grayLight }}>
              Новых лидов в месяц в среднем получают наши клиенты
            </span>
          </div>
          <div>
            <span css={{ color: colors.blue }}>80%</span>
            <span css={{ color: colors.blue }}>
              Пользователей рассказывает о сервисе своим друзьям
            </span>
          </div>
          <div>
            <span css={{ color: colors.black }}>10 часов</span>
            <span css={{ color: colors.grayLight }}>
              В среднем помогает сэкономить времени в неделю
            </span>
          </div>
        </div>

        <div
          css={{
            justifyContent: 'center',
            width: '100%',
            '@media (min-width:992px)': { justifyContent: 'flex-start' },
          }}
        >
          {/* <RouterLink to="/lk" target="_blank">
          </RouterLink> */}
          <Button
            onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
            type="blue"
            icon={arrowRight}
          >
            Попробовать бесплатно
          </Button>
        </div>

        <img
          src={dots}
          css={{
            position: 'absolute',
            display: 'none',
            zIndex: -1,
            left: '90%',
            top: 125,
            right: -90,
            '@media (min-width:992px)': { display: 'block' },
            '@media (min-width:1366px)': { left: 'calc(33% + 5px)', right: 'unset' },
          }}
        />
      </div>

      <Divider
        css={{
          marginTop: 50,
          '@media (min-width:992px)': { marginTop: 85 },
          '@media (min-width:1366px)': { marginTop: 120 },
        }}
      />
    </Section>
  </Container>
);

export default S8;
